import angular from 'angular';

import alphaSelect from "./alphaSelect";

export default angular.module('alphaSelect', [])
    .component("alphaSelect", alphaSelect)
    .name;


// WEBPACK FOOTER //
// ./app/common/widgets/alphaSelect/index.js